import Vue from 'vue'

const subDivision = {
  state: {
    subDivision: [],
    selectedSubDivision: {},
  },

  getters: {
    subDivision(state) {
      return state.subDivision
    },
    selectedSubDivision(state) {
      return state.selectedSubDivision
    },
  },

  mutations: {
    subDivision(state, payload) {
      state.subDivision = payload
    },
    selectedSubDivision(state, payload) {
      state.selectedSubDivision = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedSubDivision(context, payload) {
      context.commit('selectedSubDivision', payload)
    },
    loadSubDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'SubDivision'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('subDivision', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedSubDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'SubDivision/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedSubDivision', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateSubDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SubDivision/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'sub division updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSubDivision')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createSubDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SubDivision`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'sub division created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSubDivision')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveSubDivision(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateSubDivision', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createSubDivision', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteSubDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SubDivision/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'sub division deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSubDivision')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default subDivision
